import dayjs from "dayjs";
import bcrypt from 'bcryptjs'
import { Base64 } from 'js-base64'
import { revocationToken } from "./dgr-service";
import { environment } from "../environment";
Base64.extendUint8Array();

const createHash = require("sha256-uint8array").createHash;
// const base64url = require("base64url");


export function Base64Encoder(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
}

export function Base64Decoder(base64str) {
  return decodeURIComponent(escape(window.atob(base64str))); // For URL Encoder UTF-8 convert
  // return window.atob(base64str);
}

export function setTokenInfo(r) {
    sessionStorage.setItem('expires_in', r.expires_in.toString());
    sessionStorage.setItem('jti', r.jti);
    sessionStorage.setItem('node', r.node);
    sessionStorage.setItem('refresh_token', r.refresh_token);
    sessionStorage.setItem('scope', r.scope);
    sessionStorage.setItem('token_type', r.token_type);
    sessionStorage.setItem('access_token', r.access_token);
    sessionStorage.setItem('id_token', r.id_token);
    sessionStorage.setItem('idp_type', r.idp_type);
}

export function writeToken(token, value) {
    sessionStorage.setItem(token, value);
}

export function decodeJWT(string) {
    return parseJwt(string);
}

function parseJwt(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export function cryptSignCode() {

}

export function getReqHeader(txID) {
    /**
     * txSN 格式為 ServerNo(1) + Date(yyMMddHHmmss) + AlphaNumber(6)
     * ex. "1180823173301000001" (不可重複)
     * (ServerNo + 2018/8/23 17:33:01 + 最後6碼可英數字)"
     */
    //ServerNo 固定為1
    let serverno = '1';
    let d = new Date();
    let date = dayjs(d).format('YYMMDDHHmmss');
    // let alphaNumber = generate({ length: 6, numbers: true });
    let alphaNumber = generatePassword(6);

    let txDate = formateDate(d);
    let _locale = '';
    if(getLocale().indexOf('-')>-1){ 
      _locale =  getLocale().split('-');
    }else{
      _locale = getLocale(); //有些語系沒有-只有前綴故需另外判斷 2024/03/01
    }

    return {
        txSN: `${serverno}${date}${alphaNumber}`,
        txDate: txDate,
        txID: txID,
        cID: sessionStorage.getItem('decode_token') ? JSON.parse(sessionStorage.getItem('decode_token'))['client_id'] : '',
        locale: Array.isArray(_locale)?`${_locale[0].toLowerCase()}-${_locale[1]}`:_locale.toLowerCase()
    };
}

export function getESGReqHeader(txID) {
  /**
   * txSN 格式為 ServerNo(1) + Date(yyMMddHHmmss) + AlphaNumber(6)
   * ex. "1180823173301000001" (不可重複)
   * (ServerNo + 2018/8/23 17:33:01 + 最後6碼可英數字)"
   */
  //ServerNo 固定為1
  let serverno = '1';
  let d = new Date();
  let date = dayjs(d).format('YYMMDDHHmmss');
  // let alphaNumber = generate({ length: 6, numbers: true });
  let alphaNumber = generatePassword(6);

  let txDate = formateDate(d);
  let _locale = '';
    if(getLocale().indexOf('-')>-1){ 
      _locale =  getLocale().split('-');
    }else{
      _locale = getLocale(); //有些語系沒有-只有前綴故需另外判斷 2024/03/01
    }
  return {
      // ctxSn: `${serverno}${date}${alphaNumber}`,
      // txDate: txDate,
      txId: txID,
      cID: sessionStorage.getItem('decode_token') ? JSON.parse(sessionStorage.getItem('decode_token'))['client_id'] : '',
      locale: Array.isArray(_locale)?`${_locale[0].toLowerCase()}-${_locale[1]}`:_locale.toLowerCase()
  };
}

export function getRefreshTokenHeader(txID){
  let _locale = '';
  if(getLocale().indexOf('-')>-1){ 
    _locale =  getLocale().split('-');
  }else{
    _locale = getLocale(); //有些語系沒有-只有前綴故需另外判斷 2024/03/01
  }
  return{
    txId: txID,
    locale: Array.isArray(_locale)?`${_locale[0].toLowerCase()}-${_locale[1]}`:_locale.toLowerCase()
  }

}




function generatePassword(passwordLength) {
    var numberChars = "0123456789";
    var upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var lowerChars = "abcdefghijklmnopqrstuvwxyz";
    var allChars = numberChars + upperChars + lowerChars;
    var randPasswordArray = Array(passwordLength);
    randPasswordArray[0] = numberChars;
    randPasswordArray[1] = upperChars;
    randPasswordArray[2] = lowerChars;
    randPasswordArray = randPasswordArray.fill(allChars, 3);
    return shuffleArray(randPasswordArray.map(function(x) { return x[Math.floor(Math.random() * x.length)] })).join('');
  }

  function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  export function formateDate(date) {
    let TZD = date.toString().match(/([-+][0-9]+)\s/)[1];
    return dayjs(date).format(`YYYYMMDD[T]HHmmss[${TZD}]`);
  }

  export function formateDate_dash(date) {
    let TZD = date.toString().match(/([-+][0-9]+)\s/)[1];
    return dayjs(date).format(`YYYY-MM-DD[T]HH:mm:ss[${TZD}]`);
  }

  export function formateDate_formal(date) {
    let TZD = date.toString().match(/([-+][0-9]+)\s/)[1];
    return dayjs(date).format(`YYYY-MM-DD[T]HH:mm:ss.sss[${TZD}]`);
  }

  export function getLocale() {
    let defaultLang = (navigator.language || 'en-us').toUpperCase();    
    return defaultLang;
  }

  // 取得目前語系
  export const getCurrentLocale = () => {
    let _locale = "";
    if (getLocale()?.indexOf("-") > -1) {
      _locale = getLocale()?.split("-");
    } else {
      _locale = getLocale();
    }
    return Array.isArray(_locale) ? `${_locale[0]?.toLowerCase()}-${_locale[1]}` : _locale?.toLowerCase();
  };

  export const isNotBlank = (value) => value !== undefined && value !== null && value !== "";

  export const encoder = (dataList, code) => {
           const findItemIndex = (list, code) => {
             const found = list.find((item) => item.subitemNo === code);
             return found ? found.index : false;
           };
           if (!isNotBlank(code) || !dataList || dataList.length === 0) return null;
           return Base64Encoder(BcryptEncoder(code)) + "," + findItemIndex(dataList, code);
         };

  /**
   * 獲取當前語系的數值格式配置
   * 支援多種語系的數值表達方式，預設為英文格式（點號小數點）
   * 
   * ============================================================================
   * 未來添加新語系格式的方法
   * ============================================================================
   * 
   * 1. 在此函數中添加新的語系判斷：
   *    if (currentLocale.startsWith('fr')) {  // 法語系
   *      return {
   *        decimalSeparator: ',',      // 法語系使用逗號作為小數點
   *        thousandsSeparator: ' ',    // 法語系使用空格作為千分位
   *        pattern: 'french'           // 語系模式標識
   *      };
   *    }
   * 
   * 2. 常見語系配置參考：
   *    - 英文系 (en): decimalSeparator: '.', thousandsSeparator: ','
   *    - 越南語系 (vi): decimalSeparator: ',', thousandsSeparator: '.'
   *    - 法語系 (fr): decimalSeparator: ',', thousandsSeparator: ' ' (空格)
   * 
   * 3. 注意事項：
   *    - 語系代碼必須使用小寫 (currentLocale.toLowerCase())
   *    - 語系代碼支援多種格式：'fr', 'fr-FR', 'fr-CA' 等
   *    - 新增語系後，系統會自動支援該語系的數值格式
   * 
   * @returns {Object} 數值格式配置物件
   */
  export function getNumberFormatConfig() {
    const currentLocale = getLocale().toLowerCase();
    
    // 預設配置（英文格式）
    const defaultConfig = {
      decimalSeparator: '.',      // 小數點符號
      thousandsSeparator: ',',    // 千分位符號
      pattern: 'default'          // 格式模式
    };

    // 越南語系配置
    if (currentLocale.startsWith('vi')) {
      return {
        decimalSeparator: ',',      // 越南語系使用逗號作為小數點
        thousandsSeparator: '.',    // 越南語系使用點號作為千分位
        pattern: 'vietnamese'       // 越南語系模式
      };
    }

    // 其他語系使用預設配置
    return defaultConfig;
  }

  /**
   * 判斷是否使用逗號作為小數點的語系
   * 目前支援：越南語系
   * 未來可擴充：法語系、德語系等
   * @returns {boolean} 是否使用逗號小數點
   */
  export function usesCommaDecimal() {
    const config = getNumberFormatConfig();
    return config.decimalSeparator === ',';
  }

  /**
   * 獲取當前語系的小數點符號
   * @returns {string} 小數點符號
   */
  export function getDecimalSeparator() {
    const config = getNumberFormatConfig();
    return config.decimalSeparator;
  }

  /**
   * 獲取當前語系的千分位符號
   * @returns {string} 千分位符號
   */
  export function getThousandsSeparator() {
    const config = getNumberFormatConfig();
    return config.thousandsSeparator;
  }

  
  export async function tokenExpired() {
    const accessToken = sessionStorage.getItem('access_token')
    if(!accessToken) return true;

    const decodedJwt = await parseJwtContent(accessToken);        
    // console.log('tokenExpired=>' , decodedJwt.exp * 1000 < Date.now());
    const expired = decodedJwt.exp * 1000 < Date.now();
    return expired;
    
  }

  const parseJwtContent = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  };


  export function BcryptEncoder(encodeStr) {    
    return bcrypt.hashSync(encodeStr, 4);
  }

  export function convertEncodeStatusIndex(encodeStatus){
    switch(encodeStatus){
      case '1':
        return 0;
      case '2':
        return 1;
      case '3':
        return 3;
      default:
        return -1;      

    }
  }
  //系統變數
  export function queryItemReqBody(itemNo,orderNo){
    let reqBody = {
      encodeItemNo: Base64Encoder(BcryptEncoder(itemNo))+ ','+ parseInt(orderNo),
      isDefault: 'N'
    }
    return reqBody;
  }

  export function checkDpSuccess(res, errorCode) {        
    return errorCode ? res?.data?.ResHeader?.rtnCode === errorCode : res?.data?.ResHeader?.rtnCode === '1100' ;
  }

  export function writeAcConf(acConf) {
    sessionStorage.setItem("AcConf", acConf);
  }

  export function getAcConfEdition() {
    return sessionStorage.getItem('AcConf') ? JSON.parse(sessionStorage.getItem('AcConf'))['edition'] : undefined;
  }

  export function getAcConfExpiryDate() {
    return sessionStorage.getItem('AcConf') ? JSON.parse(sessionStorage.getItem('AcConf'))['expiryDate'] : undefined;        
  }
  
  export function getAcConfAccount() {
    return sessionStorage.getItem('AcConf') ? JSON.parse(sessionStorage.getItem('AcConf'))['account'] : undefined;        
  }

  export function writeRoleFuncCodeList(funcCodeList) {
    sessionStorage.setItem('roleFuncCodeList', funcCodeList);
  }

  export function setHyperLinkAuth(result) {
    sessionStorage.setItem('HyperLinkAuth', JSON.stringify(result));
  }

  export function getRoleFuncCodeList(){
    return sessionStorage.getItem('roleFuncCodeList') ? sessionStorage?.getItem('roleFuncCodeList')?.split(',') : [];
  }

    export function getFuncList() {
    return sessionStorage?.getItem('func_list') ? JSON.parse(sessionStorage?.getItem('func_list')) : undefined;
  }

  export function getCompanyType() {
    return sessionStorage?.getItem('companyType') ? sessionStorage?.getItem('companyType') : '';
  }

  export function getCompanySeq() {
    return sessionStorage?.getItem('companySeq') ? sessionStorage?.getItem('companySeq') : '';
  }

  export function getAcct() {
    return sessionStorage?.getItem('acct') ? sessionStorage?.getItem('acct') : '';
  }

  export function getIdpType() {
    return sessionStorage?.getItem('idp_type') ? sessionStorage?.getItem('idp_type') : '';
  }

  export function handleSessionClear(delInviteSeq=false){
    const sessionKeys = Object.keys(sessionStorage);
    for (const key of sessionKeys) {
      if(delInviteSeq===true){
        if(key!=='loadTheme' && key!=='countError'){
          sessionStorage.removeItem(key)
         }
      }else{
        if(key!=='loadTheme' && key!=='inviteseq' && key!=='countError'){
          sessionStorage.removeItem(key)
         }
      }
      
       
      // const value = sessionStorage.getItem(key);
      // console.log(`Key: ${key}, Value: ${value}`);
    }
  }

  export function loginClientId(theme){
    let clientId = "EsgCustomer"
      switch(theme){
        case 'green':
          clientId = "EsgCustomer"
          break;
        case 'blue':
          clientId = "EsgConsultant"
          break;
        case 'mint':
          clientId = "EsgManager"
          break;    
      }
      return clientId
  }

  // export function getAuthorities() {
  //   const decode_token = sessionStorage.getItem('decode_token')??'';
  //   return JSON.parse(decode_token)['authorities'];
  // }

// export { Base64Encoder, setTokenInfo, writeToken, decodeJWT, getReqHeader, generatePassword, cryptSignCode,
//     formateDate, getLocale, tokenExpired }  


//轉 code 碼 2023/02/18
export function getEncoderByItemNo(itemNo,orderNo){
  return  Base64Encoder(BcryptEncoder(itemNo))+ ','+ parseInt(orderNo)
}

// 頁面funcCode 拿 多國語系對照內容
export function getTitleByFuncCode(pathname,noAdv= false) {
  // console.log(pathname.split('/').filter(path=> path !== ''))
  const funcCode = pathname.split('/').filter(path=> path !== '')[noAdv?1:0]
  // console.log(pageId)
  const funcItem = JSON.parse(sessionStorage.getItem('func_list')).find(item=> item.funcCode.toLowerCase() === funcCode)
  
  // return funcItem ? funcItem.funcName : pathname;
  return {
    funcCode: funcCode,
    funcName:funcItem?.funcName,
  };
}

export const getBreadcrumbs = (pathname) => {  
  const pathPool = pathname.split('/').filter(path=> path !== '');
  let pageroot = `/${pathPool[0]}`;  
  let breadcrumbs = []  
  for (let index = 1; index < pathPool.length; index++) {
    pageroot += `/${pathPool[index]}`;
    breadcrumbs.push({
      title: pathPool[index],
      path: pageroot
    })  
  }
  return breadcrumbs;
}


export function generateCAPI() {
  const _uuid = generate_uuid().toUpperCase();
  // const _uuid = 'C6F43229-5ABB-40D1-B127-018DACC9F06D';
  let uuidEncode = {
    uuid: _uuid,
    capi: encodeUUID(_uuid)
  }

  return uuidEncode;
}

// CAPI key演算法流程
function encodeUUID(uuid) {
  if (typeof uuid !== "string" || uuid.length === 0) return "";
  const sTpi = "TPIdigiLogs";
  const arrayTpi = Uint8Array.of(0x80);
  const textEncoder = new TextEncoder();

  try {
    let sTarget = uuid.toLocaleUpperCase() + sTpi;

    let u8PayloadBytes = textEncoder.encode(sTarget);
    let u8Result = concatenate(Uint8Array, u8PayloadBytes, arrayTpi);

    let sSha256 = createHash("sha256").update(u8Result).digest();
    let sHalfSha256 = sSha256.subarray(sSha256.length / 2, sSha256.length);    
    // const result = base64url(sHalfSha256);
    // const result = Base64.encodeURL(sHalfSha256);
    const result = (sHalfSha256).toBase64URL();
    // console.log(result)
    return result;
  } catch (e) {
    console.log('e', e)
    return e;
  }
}


function generate_uuid() {
  var d = Date.now();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); //use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & (0x3 | 0x8))).toString(16);
  });
}

function concatenate(resultConstructor, ...arrays) {
  let totalLength = 0;
  for (const arr of arrays) {
    totalLength += arr.length;
  }
  const result = new resultConstructor(totalLength);
  let offset = 0;
  for (const arr of arrays) {
    result.set(arr, offset);
    offset += arr.length;
  }
  return result;
}

//日期相關 fun
export function addDate(date, num) {
  return dayjs(date).add(num, 'day').toDate()
}

export function addMinute(date, num) {
  return dayjs(date).add(num, "minute").toDate()
}

export function setformate(date,format){
  if(date === null || date === undefined || date === "" ){
    return null;
  }
  return dayjs(date).format(format);
}

export function replaceDateDash(date,mark){
  return date.replace(/-/g,mark);
}

export function Base64UrlEncode(tar)
{ 
  const result = Base64.encodeURL(tar)  
  return result;  
}

//顯示form name錯誤訊息
export function getFormErrorMessage(errors,name){
  if (name && name.split('.').length > 1) {
    const alertMsg = getValidateErrorByFieldId(errors, name)
    return alertMsg ? <small className="p-error">{alertMsg.message}</small> : <></>; //<small className="p-error">&nbsp;</small>;
  }
  else
    return errors[name] ? <small className="p-error">{errors[name].message}</small> : <></>; //<small className="p-error">&nbsp;</small>;
  // return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
};



export function getValidateErrorByFieldId(errors, id) {
  
  let errorObj = undefined;
  if (id && id.split('.').length > 1 && Object.keys(errors).length > 0) {
    // console.log('id', id)
    // console.log('errors', errors)
    let tarErrors = errors;
    let errorObjCheckIdx = 0;
    const idArr = id.split('.');
    // console.log('複雜欄位檢核', idArr)
    idArr.forEach((res, idx) => {
      if (tarErrors[res]) {
        errorObjCheckIdx = idx
        tarErrors = tarErrors[res];
      }
    })

    if (errorObjCheckIdx === idArr.length - 1) {
      errorObj = tarErrors
    } else errorObj = undefined;    
    return errorObj;
  }
}

/**
 * 新增 CSS class name 到 DOM 元素
 * @param element DOM 元素
 * @param className CSS class name
 */
export const addClassName = (element, className) => {
  element.classList.add(className)
}

/**
 * 從 DOM 元素移除 CSS class name
 * @param element DOM 元素
 * @param className CSS class name
 */
export const removeClassName = (element, className) => {
  element.classList.remove(className)
}

/**
 * 從 DOM 元素移除 CSS class name
 * @param element DOM 元素
 * @param className CSS class name
 */
export const toggleClassName = (element, className) => {
  element.classList.toggle(className)
}

export const checkRespSuccess = (res, errorCode) => {
  return errorCode ? res?.data?.ResHeader?.rtnCode === errorCode : res?.data?.ResHeader?.rtnCode === '1100';
}

//取得檔案上傳的File 轉成 base64字串去除 data:image/png,
export const getFileBase64 = (file)=>{
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
      // if ((encoded.length % 4) > 0) {
      //   encoded += '='.repeat(4 - (encoded.length % 4));
      // }
      resolve(reader.result);
    };
    reader.onerror = error => reject(error);
  });
}

/**
 * base64Data 有包含 data:image/png, 的base64Data
 * ***/
export const dataURItoBlob = (base64Data) =>{ //轉回BLOB URL 可直接給image使用
  let byteString;
  if(base64Data.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(base64Data.split(',')[1]);//base64 解碼
  else{
      byteString = unescape(base64Data.split(',')[1]);
  }
  let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];//mime類型 -- image/png

  let ia = new Uint8Array(byteString.length);
  for(let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  let blob = new Blob([ia], {
      type: mimeString
  });

  // return blob;
  return URL.createObjectURL(blob);

}

/**
 * base64Data 有包含 data:image/png, 的base64Data
 * ***/
export const dataURItoBlobType = (base64Data) =>{ //轉回BLOB 
  let byteString;
  if(base64Data.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(base64Data.split(',')[1]);//base64 解碼
  else{
      byteString = unescape(base64Data.split(',')[1]);
  }
  let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];//mime類型 -- image/png

  let ia = new Uint8Array(byteString.length);
  for(let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  let blob = new Blob([ia], {
      type: mimeString
  });

  return blob;

}


/**
 * base64Str 從後端取回的base64文字 沒有加前綴 data:image/png,
 * fileExtension 副檔名 (ex) png
 * ***/

export const combinePrefixBase64Image = (base64Str,fileExtension)=>{
  if(base64Str!==null && fileExtension!==null){
    if(fileExtension==='pdf'){
      return `data:application/octet-stream;base64,${base64Str}`
    }else if(fileExtension==='zip'){
      return `data:application/x-zip-compressed;base64,${base64Str}`
    }else{
      return `data:image/${fileExtension};base64,${base64Str}`
    }
  }else{
    return "";
  }
}

//從base64Data轉回 File檔案
/**
 * dataurl 'data:image/png; 
 * fileName 檔名 brid.png
 * **/
export const  dataURLtoFile =(dataurl, fileName)=> {
  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, {type:mime});
}

/****
 * base64Data 無前面的 data:application/octet-stream;base64
 * 給活動數據檢視附圖為pdf用
 * 
*/
export const handelBase64PdfToBlob = (base64Data)=>{
  // 將 base64 字符串解碼為二進制資料
const binaryData = atob(base64Data);

// 將二進制資料轉換為 Uint8Array
const bytes = new Uint8Array(binaryData.length);
for (let i = 0; i < binaryData.length; i++) {
  bytes[i] = binaryData.charCodeAt(i);
}

// 創建 Blob 對象
const pdfBlob = new Blob([bytes], { type: 'application/pdf' });
// 可選: 創建短網址
const fileURL = URL.createObjectURL(pdfBlob);
// fileURL 即為 PDF 文件的短網址
return fileURL
}

export const splitFileName = (fileName)=>{
  if(fileName){
    return fileName?.substring(0, fileName?.lastIndexOf('.'))
  }else{
    return ''
  }
}

export const splitFileExtension = (fileName)=>{
  if(fileName){
    return fileName?.substring(fileName?.lastIndexOf('.')+ 1,fileName?.length)
  }else{
    return ''
  }
}

export const handleLogout = () => {
  //註銷token access_token refresh_token
  revocationToken('access_token')
    .then((res) => {
      if (res?.status === 200) {
        return revocationToken('refresh_token');
      }
    })
    .then((res) => {
      if (res?.status === 200) {
        handleSessionClear(true);//不要將loadTheme刪除 系統設定的主題色
        window.location.replace(`/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login`)

      }
    })

}

// mask ISO27701
export const getMaskedString = (type, value = "", maxLength = 15) => {
  if (!value) return "";

  // 根據長度進行不同的遮罩
  if (value.length === 2) {
    return value[0] + "*"; // 只遮住第二個字符
  } else if (value.length === 3) {
    return value[0] + "*" + value[2]; // 遮住中間的字符
  } else if (value.length === 4) {
    return value.substring(0, 2) + "*".repeat(2); // 遮住最後兩個字符
  } else if (value.length <= 3) {
    return "*".repeat(value.length); // 長度小於等於3的直接全部遮罩
  }

  // 專門處理長字串的通用遮罩邏輯
  const maskLongString = (val) => {
    if (val.length <= maxLength) {
      return val.substring(0, 3) + "*".repeat(val.length - 3);
    }
    return (
      val.substring(0, 3) +
      "*".repeat(10)
    );
  };

  // 原本的邏輯，處理較長的字串
  switch (type) {
    case "email":
    case "account":
      if(value?.indexOf("@")>-1){
        const [user, domain] = value.split("@");
        if (!user || !domain) return value;
        if (user.length <= 3) return "*".repeat(user.length) + "@" + domain;
        return (
          user.substring(0, 3) +
          "*".repeat(user.length - 4) +
          user.slice(-1) +
          "@" +
          domain
        );  
      }else{
        return maskLongString(value);
      }  
    case "username":
    case "name":   
    case "phone":     
    case "address":
        return maskLongString(value);
      default:
        return value;
  }
};





